import { render, staticRenderFns } from "./Carteras.vue?vue&type=template&id=21c9d821&"
import script from "./Carteras.vue?vue&type=script&lang=js&"
export * from "./Carteras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports